import { PropsWithChildren, createContext, useMemo } from 'react';

import { Cluster } from '@cast/types';

type ClusterContextProps = {
  cluster: Cluster;
  isLoading: boolean;
  error?: string;
};

export const ClusterContext = createContext<ClusterContextProps>({
  isLoading: false,
  cluster: { id: '' } as never,
});

type ClusterProviderProps = {
  cluster: Cluster;
  isLoading?: boolean;
  error?: string;
};

export const ClusterProvider = ({
  children,
  cluster,
  isLoading = false,
  error,
}: PropsWithChildren<ClusterProviderProps>) => {
  const value = useMemo(
    () => ({ cluster, isLoading, error }),
    [cluster, isLoading, error]
  );

  return (
    <ClusterContext.Provider value={value}>{children}</ClusterContext.Provider>
  );
};
